<h4 translate="services.webcam.title"></h4>

<div class="btn-bar">
  <button class="btn btn-primary" [appHasAnyRole]="[AppRoles.superAdmin]"
    (click)="createOrEditWebcam()"
    translate="services.webcam.actions.add">
  </button>
  @if (webcams.length > 1) {
    <button class="btn btn-primary"
      (click)="orderWebcams()"
      translate="common.sort">
    </button>
  }
</div>

<div class="table-responsive">
  <table class="table table-striped"
    [attr.aria-label]="'common.webcams' | translate">
    <thead>
      <tr>
        <th scope="col" style="min-width:175px" translate="services.webcam.table.location"></th>
        <th scope="col" style="min-width:250px" translate="services.webcam.table.imageUrl"></th>
        <th scope="col" style="min-width:275px" translate="services.webcam.table.description"></th>
        <th scope="col" style="min-width:100px"></th>
      </tr>
    </thead>

    <tbody>
      @if (webcams.length === 0) {
        <tr>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td></td>
        </tr>
      }

      @for (webcam of webcams; track webcam) {
        <tr>
          <td>{{ webcam['location' + crtLang.toUpperCase()] }}</td>
          <td style="max-width:250px;" class="text-truncate">{{ webcam.imageUrl }}</td>
          <td>{{ webcam['description' + crtLang.toUpperCase()] }}</td>
          <td class="text-end">
            @if (!webcam.active) {
              <button class="btn btn-link btn-sm text-danger"
                (click)="activateWebcam(webcam)"
                title="{{'common.tooltip.deactivate' | translate}}">
                <fa-icon [icon]="icons.toggleOff"></fa-icon>
              </button>
            } @else {
              <button class="btn btn-link btn-sm text-success"
                (click)="deactivateWebcam(webcam)"
                title="{{'common.tooltip.activate' | translate}}">
                <fa-icon [icon]="icons.toggleOn"></fa-icon>
              </button>
            }
            <button class="btn btn-link btn-sm"
              (click)="updateWebcam(webcam)"
              title="{{'common.tooltip.edit' | translate}}">
              <fa-icon [icon]="icons.edit"></fa-icon>
            </button>
            <button class="btn btn-link btn-sm" [appHasAnyRole]="[AppRoles.superAdmin]"
              (click)="deleteWebcam(webcam)"
              title="{{'common.tooltip.delete' | translate}}">
              <fa-icon [icon]="icons.delete"></fa-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
